import { Inject } from '@rxdi/core';
import { Component, css, html, LitElement } from '@rxdi/lit-html';
import { ScrollToService } from '@shared/services';

import { ContactComponent } from './contact/contact.component';
import { FrameworksComponent } from './frameworks/frameworks.component';
import { HeroComponent } from './hero/hero.component';
import { MissionComponent } from './mission/mission.component';
import { ProblemComponent } from './problem/problem.component';
import { ServicesComponent } from './services/services.component';
import { ShowcaseComponent } from './showcase/showcase.component';
import { TimelineComponent } from './timeline/timeline.component';

/**
 * @customElement home-component
 */
@Component({
  selector: 'home-component',
  components: [
    HeroComponent,
    ProblemComponent,
    TimelineComponent,
    FrameworksComponent,
    MissionComponent,
    ServicesComponent,
    ShowcaseComponent,
    ContactComponent,
  ],
  styles: [
    css`
      :host {
        display: block;
        color: white;
      }
    `,
  ],
  template() {
    return html`
      <hero-component></hero-component>
      <services-component></services-component>
      <timeline-component></timeline-component>
      <mission-component></mission-component>
      <problem-component></problem-component>
      <frameworks-component></frameworks-component>
      <showcase-component></showcase-component>
      <contact-component></contact-component>
    `;
  },
})
export class HomeComponent extends LitElement {
  @Inject(ScrollToService)
  private scrollToService: ScrollToService;

  OnUpdateFirst() {
    this.scrollToService.setElements(Array.from(this.shadowRoot.querySelectorAll('*')) as HTMLElement[]);
  }
}
